import { ref } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { useCookies } from '@vueuse/integrations/useCookies'
export const useStore = createGlobalState(() => {
  // state
  const locationId = ref('')
  const storeId = ref('')
  const isLogin = ref(false)
  const token = ref('')
  const storeName = ref('')
  const user = ref({
    name: '',
    email: '',
  })
  const productDetailPath = ref('')
  const cookies = useCookies()

  const logout = () => {
    cookies.remove(`token_${storeId.value}`, {
      path: '/',
    })

    isLogin.value = true
    token.value = ''

    user.value = {
      name: '',
      email: '',
    }
  }

  return { locationId, storeId, isLogin, token, storeName, user, productDetailPath, logout }
})
